module.exports = __webpack_public_path__ + "img/flower-cycle-plain.5b75f87e.svg";